import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicationDepositSourceType implements Deserializable {
  public ApplicationNumber?: number;
  public DepositSourceTypeCode: string;
  public DepositSourceTypeID: number;
  public DepositSourceTypeDetails: string;
  public DepositSourceTypeAmount?: number;
  public LiabilityForTaxDescription: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
